export default __webpack_public_path__ + "static/upch-7c7ce15768917c93fc7f048ffc92b4ff.png";